// @ts-nocheck
import React from 'react'
import * as R from 'ramda'

import actionFactory from './actionFactory'
import KebabAction from './KebabAction'
import { connect } from 'react-redux'

const actionList = (model, items) => (props = {}) =>
  R.pipe(
    R.toPairs,
    R.map(([name = '??', defaultProps = {}]) =>
      actionFactory(name)({ model, ...defaultProps, ...props }),
    ),
  )(items)

const listDefaultItems = {
  create: { primary: true },
  export: { kebab: true },
  trash: { kebab: true },
}

export const listActionsFactory = (model, items = listDefaultItems) => {
  const mapStateToProps = state => {
    const pks = model.getSelectedItemIds(state)
    return pks.length ? { pks } : {}
  }
  return connect(mapStateToProps)(
    detailActionsFactory(model, items, 'CardActions'),
  )
}

const detailDefaultItems = { trash: { kebab: true } }

export const detailActionsFactory = (
  model,
  items = detailDefaultItems,
  className = 'DetailActions',
) => {
  const [b, a] = R.partition(R.prop('kebab'), items)
  const toolActions = actionList(model, a)
  const kebabActions = actionList(model, b)

  const shouldAllowKebabActions = R.equals(R.length(R.keys(b)), 0)

  return ({ ...props }) => {
    if (props.pk && !props.pks) props.pks = [props.pk]
    return (
      <div className={className}>
        {toolActions(props)}
        {shouldAllowKebabActions || (
          <KebabAction>{kebabActions(props)}</KebabAction>
        )}
      </div>
    )
  }
}
